
import { FiltrosHistorial, Opcion, PuntoServicio, Operario, Dato } from "src/utils";
import { formatearFecha } from "src/utils";

// true si ambos son diferentes
export function XOR(a: any, b: any) {
  return a ? !b : b;
}

/* AUTOCOMPLETE */
export function opcionAPuntoServicio(opcion: Opcion | null) {
  return opcion
    ? ({
        codigo: opcion.id,
        nombre: opcion.nombre,
      } as PuntoServicio)
    : undefined;
}
/*AUTOCOMPLETE OPERARIOS */

export function opcionOperarios(usuario: Operario | null) {
  return usuario
    ? ({
      usuario: usuario.usuario,
      cargo: usuario.cargo,
      } as Operario)
    : undefined;
}
/* FILTROS DE HISTORIAL */
export function filtrosActivosATexto(filtros: FiltrosHistorial) {
  const nombrePuntoServicio = filtros.puntoDeServicio?.nombre;
  let fechaInicio, fechaFin;
  let mensaje = "";

  if (filtros.fechaInicio) fechaInicio = formatearFecha(filtros.fechaInicio);
  if (filtros.fechaFin) fechaFin = formatearFecha(filtros.fechaFin);

  mensaje = adjuntarFiltroAMsj(mensaje, "de", nombrePuntoServicio);
  mensaje = adjuntarFiltroAMsj(mensaje, "desde el", fechaInicio);
  mensaje = adjuntarFiltroAMsj(mensaje, "hasta el", fechaFin);

  if (XOR(filtros.soloHorasProcesadas, filtros.soloHorasSinProcesar)) {
    if (filtros.soloHorasProcesadas)
      mensaje = adjuntarFiltroAMsj(mensaje, "con horas", "procesadas");
    else if (filtros.soloHorasSinProcesar)
      mensaje = adjuntarFiltroAMsj(mensaje, "con horas", "sin procesar");
  }

  if (mensaje) mensaje += ".";

  return mensaje;
}

export function adjuntarFiltroAMsj(
  msjBase: string,
  predicado: string,
  valor: any
) {
  const nuevoMsj = predicado && valor ? ` ${predicado} ${valor}` : "";

  if (!nuevoMsj) return msjBase;

  if (msjBase) return `${msjBase} ${nuevoMsj}`;
  else return `Mostrando sólo registros ${nuevoMsj}`;
}

/* FUNCIONALIDADES CON CADENAS */
export function capitalize(str: string) {
  return str
    .toLocaleLowerCase()
    .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));
}


/* FILTROS DE ASIGNACION */
export function filtrosActivoAsignacion(filtros: Dato) {
  const psAsignacion = filtros.ps_nombre;
  
  return psAsignacion
  
}

/* FILTROS DE ASIGNACION */
export function psAsignacion(filtros: Dato) {
  const psAsignacion = filtros.ps_id;
  
  return psAsignacion
  
}


//DATOS DE ASIGNACION PS
// export function puntoDeServicio_DetalleAsignacion(filtros: DatosDetalles) {
//   const asignacionDetallada = filtros.cupo_asignado;
  
//   return asignacionDetallada
  
// }



